import { IDawaAddress } from './types'

export function getOptionLabel(option: IDawaAddress): string {
  if (typeof option !== 'object') return option
  return option.forslagstekst
}

export function getOptionSelected(
  option: IDawaAddress,
  value: IDawaAddress,
): boolean {
  if (typeof option !== 'object') {
    option === value
  }
  return option.madId === value.madId
}

export function modelData(data: IDawaAddress[]): IDawaAddress[] {
  return data.slice(0, 26).sort()
}

export function urlBuilder(
  searchTerm: string,
  excludeSimilar: boolean,
): string {
  return `https://address-service-pdsm-prod.public.lqd.dk/v1/autocomplete/${encodeURIComponent(
    searchTerm,
  )}?withFallback=false&excludeSimilar=${excludeSimilar}`
}
